


























import capitalize from 'lodash/capitalize'

export default {
  props: {
    stops: { type: Array, required: true, default: () => [] },
    customerCompanyName: { type: Boolean, default: false },
    stopNotes: { type: Boolean, default: false },
    contactPerson: { type: Boolean, default: false },
    referenceNumber: { type: Boolean, default: false }
  },

  methods: {
    getAlphabetEquivalent(index) {
      const utf16CodeUnit = 65
      return String.fromCharCode(utf16CodeUnit + index)
    },
    stopoverType(type) {
      return capitalize(this.$t(`marketPlace.orderDetails.stopoverType.${type}`))
    }
  }
}
